import { render, staticRenderFns } from "./helpDhcp.vue?vue&type=template&id=1c988f04&"
import script from "./helpDhcp.vue?vue&type=script&lang=js&"
export * from "./helpDhcp.vue?vue&type=script&lang=js&"
import style0 from "./helpDhcp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports